
// svg png 图片资源来自阿里字体库
// [阿里字体库](https://www.iconfont.cn/collections/index?spm=a313x.7781069.1998910419.4)
// svg图标建议使用自己创建的
import registerStart from './registerStart'
import registerUser from './registerUser'
import registerEnd from './registerEnd'
import registerPush from './registerPush'
import registerDownload from './registerDownload'
import registerPolyline from './registerPolyline'
import registerApproval from './registerApproval'
import registerTask from './registerTask'
import registerWait from './registerWait'
import registerConnect from './registerConnect'
import registerJu from './registerJu'
import registerSqlNode from './registerSqlNode'
import registerEntity from './registerEntity'
import registerPosition from './registerPosition'
import registerSubFlow from './registerSubFlow'
import registerCircle from './registerCircle'

export { registerStart, registerUser, registerEnd, registerPush, registerDownload,
    registerPolyline,registerApproval, registerTask, registerWait, registerConnect,registerJu,registerSqlNode,
    registerEntity,registerPosition,registerSubFlow,registerCircle }
